export const calculateBMR = (weight, height, age, gender) => {
  if (gender === 'male') {
    return (10 * weight) + (6.25 * height) - (5 * age) + 5;
  } else {
    return (10 * weight) + (6.25 * height) - (5 * age) - 161;
  }
};

export const calculateTDEE = (bmr, activityLevel) => {
  const activityMultipliers = {
    sedentary: 1.2,
    light: 1.375,
    moderate: 1.55,
    active: 1.725,
    veryActive: 1.9,
    athlete: 2.2
  };

  return bmr * (activityMultipliers[activityLevel] || 1.2);
};

export const calculateBodyFat = (measurements, gender) => {
  const { waist, neck, height, hips } = measurements;
  
  if (gender === 'male') {
    return 495 / (1.0324 - 0.19077 * Math.log10(waist - neck) + 0.15456 * Math.log10(height)) - 450;
  } else {
    return 495 / (1.29579 - 0.35004 * Math.log10(waist + hips - neck) + 0.22100 * Math.log10(height)) - 450;
  }
};

export const calculateMacros = (calories, weight, goal) => {
  let proteinMultiplier = 0.8;
  let fatPercentage = 0.25;
  
  switch (goal) {
    case 'cutting':
      proteinMultiplier = 1.0;
      fatPercentage = 0.20;
      break;
    case 'bulking':
      proteinMultiplier = 0.8;
      fatPercentage = 0.30;
      break;
    case 'maintenance':
    default:
      proteinMultiplier = 0.8;
      fatPercentage = 0.25;
      break;
  }
  
  const protein = Math.round(weight * 2.2 * proteinMultiplier);
  const fat = Math.round((calories * fatPercentage) / 9);
  const carbs = Math.round((calories - (protein * 4) - (fat * 9)) / 4);
  
  return { protein, fat, carbs };
};

export const calculateCaloriesForGoal = (tdee, goal) => {
  switch (goal) {
    case 'cutting':
      return Math.round(tdee * 0.8);
    case 'bulking':
      return Math.round(tdee * 1.1);
    case 'maintenance':
    default:
      return Math.round(tdee);
  }
};

export const formatNumber = (num) => {
  return Math.round(num).toLocaleString();
};